import { ToDateTimeText, ToDateFullMonthText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import Alarm from '@material-ui/icons/Alarm';
import Link from '@material-ui/core/Link';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export const getColumns = () => {
  const columns = [
    {
      dataField: "JOB_ID",
      text: "ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "JOB_NAME",
      text: "Job Name",
      sort: true,
      headerAlign: 'center',
      
    },
    {
      dataField: "CREATE_BY",
      text: "User",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TYPE",
      text: "Schedule Type",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TIME",
      text: "Schedule Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DATE_TIME_START",
      text: "Start Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
      },
    },
    {
      dataField: "DATE_TIME_END",
      text: "End Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
      },
    },
    {
      dataField: "STATUS",
      text: "Status",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      
    },
    {
      dataField: "VERTICA_SESSION_ID",
      text: "Vertica Session ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Msg",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      
    },
  ]
  return columns;
};
export const getHistoryColumns = (Download) => {
  const columns = [
    // {
    //   dataField: "TALEND_TASK_ID",
    //   text: "Task ID",
    //   sort: true,
    //   headerAlign: 'center',
    //   align: 'center',
    // },
    {
      dataField: "TALEND_REQUEST_ID",
      text: "Request ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TIME",
      text: "Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.SCHEDULE_TIME)}</>;
      },
    },
    {
      dataField: "DATE_TIME_START",
      text: "Start Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
      },
    },
    {
      dataField: "DATE_TIME_END",
      text: "End Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
      },
    },
    {
      dataField: "STATUS",
      text: "Status",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "EXECUTION_TIME",
      text: "Execution Time(Sec)",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DID",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            {(row.ISDOWNLOAD === "1") ? (

              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  Download(row.EXEC_NO);
                }}
              />

            ) : ""}
          </Box>
        );
      },
    },

  ];
  return columns;
};